import styled from 'styled-components/macro'

export const DataTablePaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
`

export const PageButton = styled.button<{
  isActive: boolean
}>`
  border: none;

  /* DS2026 pagination button — neutral light bg on active/hover, no green.
     Width hugs content for long page numbers (e.g. 10,445) while keeping a
     square 40×40 minimum hit-area for single/double digits. */
  min-width: 40px;
  height: 40px;
  padding: 0 10px;

  background-color: ${({ isActive }) => (isActive ? '#F3F4F6' : 'transparent')};
  border-radius: 8px;

  font-style: normal;
  font-weight: ${({ isActive }) => (isActive ? 600 : 500)};
  font-size: 14px;
  line-height: 20px;
  font-variant-numeric: tabular-nums;

  /* neutral-900 on active/hover, neutral-700 default (see design-tokens.cjs) */
  color: ${({ isActive }) => (isActive ? '#111827' : '#374151')};

  &:hover {
    background-color: #f3f4f6;
    color: #111827;
  }
`

export const DataTablePaginationDots = styled.div`
  margin: 0 0.5rem;
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
`

export const DataTablePaginationButtonsContainer = styled.div`
  display: flex;
  gap: 5px;
  margin: 0px 8px 0px 8px;
`
